<template>
  <div class="LKMunMehFormHeader">
    <v-layout>
      <v-tabs
        v-model="currentPage"
        hide-slider
        center-active
        height="36px"
        background-color="#00000000"
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.key"
          :value="tab.key"
          v-text="tab.text"
        />
      </v-tabs>
      <v-spacer />
      <v-btn
        color="primary"
        rounded
        outlined
        class="ml-btn"
        @click="$emit('click:next')"
        v-text="'Перейти к заполнению'"
      />
      <v-btn
        color="primary"
        rounded
        class="ml-btn"
        :disabled="isSubmitDisabled"
        :loading="isLoadingAsyncData"
        @click="onReadyToSubmit"
        v-text="'Сдать отчет'"
      />
      <v-btn
        color="primary"
        rounded
        outlined
        class="ml-btn"
        @click="onClose"
        v-text="'Закрыть'"
      />
    </v-layout>
    <div
      class="form-status"
      v-text="status"
    />
  </div>
</template>

<script>
import { lkMunMehFormMapper } from '@/views/LKMunMeh/Form/store'

import { createModalConfirm } from '@/helpers/createModalConfirm'
import { LK_MUN_MEH_FORM_ROUTES } from '@/views/LKMunMeh/Form/utils'
import { MunMehFormStatuses } from '@/typings/api/MunMeh'
import { uiDateFormatter } from '@/helpers/dateFormatter'
import { MAX_SEARCH_DEPTH } from '@/views/LKMunMeh/utils'

import MunMehHeaderMixin from '@/views/LKMunMeh/mixins/MunMehHeaderMixin'

export default {
  name: 'LKMunMehFormHeader',
  mixins: [MunMehHeaderMixin],
  props: {
    munMeh: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoadingAsyncData: false,
  }),
  computed: {
    isSubmitDisabled() {
      return [MunMehFormStatuses.submitted, MunMehFormStatuses.done].includes(this.munMeh.form.status)
    },
    status() {
      switch (this.munMeh.form.status) {
        case MunMehFormStatuses.submitted:
        case MunMehFormStatuses.done:
          return this.munMeh.form.submitted_at ? `Форма сдана ${uiDateFormatter(this.munMeh.form.submitted_at)} (мск).` : 'Форма сдана'
        default: return 'Форма не сдана'
      }
    },
  },
  methods: {
    ...lkMunMehFormMapper.mapActions(['submit']),
    goToMissed({ data, meta }) {
      if (!data || !meta) {
        return
      }

      this.$router.push({
        name: LK_MUN_MEH_FORM_ROUTES.FOURTH_LEVEL,
        params: {
          firstLevelId: meta.firstLevelId,
          secondLevelId: meta.secondLevelId,
          thirdLevelId: meta.thirdLevelId,
          fourthLevelId: data.id,
          savePosition: true,
        },
      }).catch(() => true)
    },
    findRequiredMissLevel(level, depth) {
      if (depth > MAX_SEARCH_DEPTH || !level) {
        return null
      }

      if (!level.is_filled && level.required) {
        return level
      }

      const items = level.data || level.items || []
      // eslint-disable-next-line
      for (const child of items) {
        const result = this.findRequiredMissLevel(child, depth + 1)
        if (result) {
          return result
        }
      }
      return null
    },
    async showConfirmDialog() {
      const propsData = {
        titleText: 'Подтверждение',
        mainText: 'Отчет нельзя будет отредактировать после сдачи. Вы уверены, что хотите завершить работу с отчетом?',
        cancelBtn: 'Нет',
        successBtn: 'Да',
        success: false,
        action: this.onSubmit,
      }

      const modal = await createModalConfirm(this, propsData)
      return modal.open().finally(() => modal.close())
    },
    async checkIfNotFilledLevel() {
      const nonFilledLevel = this.findRequiredMissLevel(this.munMeh.form, 1)
      if (nonFilledLevel !== null) {
        const propsData = {
          titleText: 'Проверка формы',
          mainText: 'Некоторые поля, ожидающие заполнения, не заполнены. Отчет нельзя будет отредактировать после сдачи. Вы уверены, что хотите завершить работу с отчетом?',
          cancelBtn: 'Заполнить',
          successBtn: 'Сдать отчет без заполнения',
          action: this.onSubmit,
          cancelAction: () => this.goToMissed(nonFilledLevel),
        }

        const modal = await createModalConfirm(this, propsData)
        await modal.open().finally(() => modal.close())
      }

      return nonFilledLevel === null
    },
    async onReadyToSubmit() {
      const isFilled = await this.checkIfNotFilledLevel()
      if (!isFilled) return void 0

      return this.showConfirmDialog()
    },
    async onSubmit() {
      this.isLoadingAsyncData = true
      try {
        await this.submit(this.munMeh.form.id)
        this.onClose()
      } catch (e) {
        this.$notice.errors(e)
        this.isLoadingAsyncData = false
        throw e
      }

      this.isLoadingAsyncData = false
    },
    onExcelClick() {
      this.$emit('tab:excel')
    },
    onFormClick() {
      this.$emit('tab:form')
    },
    onLogsClick() {
      this.$emit('tab:logs')
    },
  },
}
</script>

<style scoped lang="scss">
.LKMunMehFormHeader {
  @import "~@/assets/scss/components/_LKHeaderButtons.scss";

  .ml-btn {
    margin-left: 12px;
  }

  .form-status {
    margin-top: 10px;
    color: $webflow-color-blue-dark-2;
    text-align: right;
  }
}
</style>
